<template>
  <div>
    <Toast />
    <div class="form col-lg-10 mx-auto bg-white">
      <h5 class="text-center mt-2 mb-3 heading">
        Register All routes of your company
      </h5>
      <form class="mx-auto mains">
        <div class="routesdiv d-flex flex-wrap mx-auto col-12">
          <div class="form-group col-sm-6 col-12 col-lg-5">
            <input
              type="text"
              class="form-control"
              name="source"
              v-model="source"
              placeholder="From"
              required
            />
          </div>
          <div class="form-group col-sm-6 col-12 col-lg-5">
            <input
              type="text"
              class="form-control"
              name="destination"
              v-model="destination"
              placeholder="To"
              required
            />
          </div>
          <div class="text-center saveroute col-12 col-sm-6 col-lg-2">
            <button
              class="btn btn-primary"
              type="submit"
              name="newroute"
              @click.prevent="newRoute()"
            >
              Add route
              <span v-if="hasSubmitted" class="spinner-border spinner-border-sm ml-2 my-auto"></span>
            </button>
          </div>
        </div>
      </form>
      <div class="desc">
        <h4 class="mt-3">Break points</h4>
        <p class="text-secondary mb-3 exp">
          In a registered route, tell us every place where your buses stop to pick up clients.
        </p>
      </div>
      <div class="text-center mb-2 savesubroute">
        <button
          class="btn btn-primary show-modal"
          data-toggle="modal"
          :data-target="myModal"
        >
          Add Breakpoints
        </button>
      </div>

      <div class="modal fade" id="myModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <h5 class="text-primary myModal-heading mb-4">
                Register Breakpoints
              </h5>
              <form class="modalform">
                <div class="mx-auto">
                  <div class="form-group col-sm-12 col-12 col-lg-11">
                    <select
                      class="form-control"
                      v-model="regiroutes"
                      name="regiroutes"
                      id="regiroutes"
                      required
                    >
                      <option disabled value>select route</option>
                      <option
                        v-for="route in routes"
                        :key="route"
                        :value="route.id"
                      >
                        {{ route.source }}--{{ route.destination }}
                      </option>
                    </select>
                  </div>
                    <div class="form-group col-sm-12 col-12 col-lg-11">
                      <input
                        type="text"
                        class="form-control"
                        name="bp1"
                        v-model="bp1"
                        placeholder="Breakpoint"
                        required
                      />
                    </div>
                    <div class="form-group col-sm-12 col-12 col-lg-11">
                      <input
                        type="number"
                        class="form-control"
                        name="distance"
                        v-model="distance"
                        placeholder="Distance(Km) from main route"
                        required
                      />
                    </div>
                  
                </div>
                <div class="text-center regbp">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    :data-dismiss="modalClose"
                    @click="register"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    name="newbp"
                    @click.prevent="newBp()"
                    class="btn btn-primary"
                  >
                    Register
                  </button>
                  <button
                    type="submit"
                    name="newbpfinal"
                    @click.prevent="newBpFinal()"
                    class="btn btn-success"
                  >
                    Finish
                  </button>
                </div>
                <p class="text-secondary text-center exp">
                  Note that time between breakpoints will be automatic generated according to the submitted distance from the main departure point.
                  <br><span class="text-primary">⚠️click finish to register the last breakpoint and immediately close the popup to register their prices⚠️</span>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showTablebp" class="mt-4">
        <h5 class="text-primary myModal-heading mb-4">Register Prices</h5>
            <div class="priceregistration d-flex justify-content-center" v-for="(breakpoint, i) in breakpoints" :key="i">
              <div class="d-flex justify-content-between text-body mr-3 pt-2" style="width: 40%">
                <div class="d-flex justify-content-start" style="width: 30%"><p>{{breakpoint.source}}</p></div>
                <div class="d-flex justify-content-start text-secondary"><p>To</p></div>
                <div class="d-flex justify-content-start" style="width: 40%"><p>{{breakpoint.destination}}</p></div>
              </div>
              <form class="d-flex">
                    <div class="form-group col-sm-12 col-12 col-lg-11">
                      <input
                        type="number"
                        class="form-control"
                        name="price"
                        v-model="breakpoints[i].price"
                        placeholder="Price"
                        required
                      />
                    </div>          
                  <button
                    type="submit"
                    name="priceReg"
                    @click.prevent="priceReg(i)"
                    class="btn toadd btn-primary"
                  >
                    Add
                  </button>
              </form>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
const url = "https://bookinga.herokuapp.com/api/v1/company/routes";
import Axios from "axios";
import $ from "jquery";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  data() {
    return {
      modalClose: "",
      myModal: "",
      source: "",
      destination: "",
      price: "",
      routes: [
        {
          id: "",
          source: "",
          destination: "",
        },
      ],
      //breakpoints
      showTablebp: false,
      regiroutes: "",
      bp1: "",
      distance: "", 
      hasSubmitted: false,
      possibleDestinations: [],
      breakpoints: [],
    };
  },
  methods: {
    register() {
      this.modalClose = "modal";
    },
    newRoute() {
      if (this.source != "" && this.destination != "") {
        if (this.source != this.destination) {
          this.hasSubmitted = !this.hasSubmitted;
          for (let i = 0; i < this.routes.length; i++) {
            if (
              this.routes[i].source == this.source &&
              this.routes[i].destination == this.destination
            ) {
              this.hasSubmitted = false;
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: "Every route should have a unique name",
                life: 5000,
              });
            }
          }
          // this.routes.shift();
          Axios.post(
            url,
            {
              source: this.source,
              destination: this.destination,
            },
            config
          )
            .then((response) => {
              if (response.data.status == 201) {
                this.routes.unshift({
                  source: this.source,
                  destination: this.destination,
                });
                this.source = "";
                this.destination = "";
                this.hasSubmitted = false;
                return this.$toast.add({
                  severity: "success",
                  summary: "routes registration",
                  detail: "route registered successfully",
                  life: 5000,
                });
              } else {
                this.hasSubmitted = false;
                return this.$toast.add({
                  severity: "error",
                  summary: "An error occured",
                  detail: response.data.message,
                  // detail: "Wasn't able to add route, please try again!",
                  life: 5000,
                });
              }
              // console.log(response.data)
            })
            .catch((err) => {
              this.hasSubmitted = false;
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: "Wasn't able to add route, please try again!",
                life: 5000,
              });
            });
        } else {
          return this.$toast.add({
            severity: "error",
            summary: "An error occured",
            detail: "Source and destination can't be similar",
            life: 5000,
          });
        }
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "A route should have all the 2 fields",
          life: 5000,
        });
      }
    },
    newBp(){
    if (
        this.regiroutes != "" &&
        this.bp1 != "" &&
        this.distance != ""
      ) {
          this.possibleDestinations.unshift({
            routeid: this.regiroutes,
            destination: this.bp1,
            distance: this.distance,
          })
          this.bp1 = "";
          this.distance = "";

          return this.$toast.add({
            severity: "success",
            summary: "breakpoints added",
            detail: "Breakpoint added to list successfully ",
            life: 5000,
          });
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "A breakpoint combination should have all the 3 fields.",
          life: 5000,
        });
      }
    },
    newBpFinal() {
      if (
        this.regiroutes != "" &&
        this.bp1 != "" &&
        this.distance != ""
      ) {
          this.possibleDestinations.unshift({
            routeid: this.regiroutes,
            destination: this.bp1,
            distance: this.distance,
          })
          //first filter all elements that have the same route id
          let filtered = this.possibleDestinations.filter(
            (element) => element.routeid == this.regiroutes
          );
          //then delete all other elements from the possibleDestinations array
          this.possibleDestinations = filtered;
          Axios.post(
            `https://bookinga.herokuapp.com/api/v1/company/routes/${this.regiroutes}/breakpoint`,
            {possibleDestinations: this.possibleDestinations},
            config
          )
            .then((res) => {
              if (res.data.success == true) {
                
              Axios.get(`https://bookinga.herokuapp.com/api/v1/company/routes/${this.regiroutes}/breakpoint`, config)
                .then((res) => {
                  this.breakpoints = res.data.message;
                  //check if price in not null
                  for(let i = 0; i < this.breakpoints.length; i++){
                    if(this.breakpoints[i].price == null){
                      //filter the breakpoint
                      this.breakpoints = this.breakpoints.filter((item)=>{
                        return item.price == null;
                      })
                    }
                  }
                })
                .catch((err) => console.log(err));

                this.regiroutes = "";
                this.bp1 = "";
                this.distance = "";

                this.showTablebp = true;

                return this.$toast.add({
                  severity: "success",
                  summary: "breakpoints registration",
                  detail: "Breakpoints registered successfully",
                  life: 5000,
                });
              } else {
                return this.$toast.add({
                  severity: "error",
                  summary: "An error occured",
                  detail: res.data.message,
                  life: 5000,
                });
              }
            })
            .catch((err) => {
              // console.log(err)
              return this.$toast.add({
                  severity: "error",
                  summary: "An error occured",
                  detail: "failed to register breakpoints",
                  life: 5000,
              });
            });
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "A breakpoint combination should have all the 3 fields.",
          life: 5000,
        });
      }
    },
    priceReg(index){
      // console.log(this.breakpoints[index])
      let price = parseInt(this.breakpoints[index].price,10);
       if (this.breakpoints[index].price != "") {
          Axios.put(
            `https://bookinga.herokuapp.com/api/v1/company/routes/${this.breakpoints[index].routeid}/breakpoint/${this.breakpoints[index].id}/addPrice`,
            {price: price},
            config
          )
            .then((res) => {
              if (res.data.success == true) {
                //remove from list
                this.breakpoints.splice(index,1);
                this.price = "";

                return this.$toast.add({
                  severity: "success",
                  summary: "price addition",
                  detail: "Price added successfully",
                  life: 5000,
                });
              } else {
                return this.$toast.add({
                  severity: "error",
                  summary: "An error occured",
                  detail: res.data.message,
                  life: 5000,
                });
              }
            })
            .catch((err) => {
              // console.log(err)
              return this.$toast.add({
                  severity: "error",
                  summary: "An error occured",
                  detail: "failed to add price",
                  life: 5000,
              });
            });
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "A price is needed",
          life: 5000,
        });
      }
    }
  },
  created() {
    Axios.get(url, config)
      .then((res) => {
        this.routes = res.data.data;
      })
      .catch((err) => console.log(err));

    $(document).ready(function() {
      $(".show-modal").click(function() {
        $("#myModal").modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.heading {
  font-size: 20px;
  margin-top: 1%;
}
h4 {
  color: $mainDark;
  font-size: 0.9em;
}
.form {
  border-radius: 10px;
  min-height: 85vh;
}
.desc{
  text-align: center;
}
.mains {
  min-width: 85%;
}
.routesdiv {
  width: 100% !important;
  justify-content: space-between !important;

  .form-group col-sm-12 col-12 col-lg-3 {
    width: 27%;

    input {
      width: 100%;
    }
  }
}

.form-control {
  background-color: #fbfdff !important;
  border: 1px solid #e6eeff !important;
  margin: 0 !important;
  height: 40px !important;
  font-size: 12px !important;
  padding: 0 1em !important;
}
.input-group-text {
  margin: 0 !important;
  padding: 1em !important;
  height: 40px !important;
  font-size: 0.7em !important;
}
button {
  height: 40px;
  min-width: fit-content;
}
.saveroute {
  width: 12% !important;
  button {
    width: 100% !important;
  }
}
.savesubroute {
  width: 100% !important  ;
  display: flex;
  justify-content: center;
}
.showbreakpoints {
  height: 1.5rem;
  display: flex;
  align-items: center;
}
.exp {
  font-size: 0.9em;
}
table {
  border-radius: 10px !important;
  border: 1px solid #e6eeff !important;
  font-size: 13px !important;
  margin-bottom: 0 !important;
}
tr:nth-child(odd) {
  background-color: #fbfdff !important;
}
.table th,
.table thead th .table tr td,
table td {
  padding: 0.75rem;
  vertical-align: top;
  /* border-top: 1px solid #fbfdff; */
  font-size: 13px;
  border: none;
}
.table thead th {
  vertical-align: bottom;
}
thead > tr > th {
  font-weight: 300 !important;
  background-color: #1a8cbfbf;
  color: white;
  font-size: 1em !important;
}
thead > tr > th:first-child {
  border-top-left-radius: 0.25em;
}
thead > tr > th:last-child {
  border-top-right-radius: 0.25em;
}
.added-routes {
  height: 45% !important;
  border-radius: 6px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
/* Hide scrollbar for Chrome, Safari and Opera */
.added-routes::-webkit-scrollbar {
  width: 5px;
}
.added-routes::-webkit-scrollbar-thumb {
  width: 5px;
  background-color: #0069d9;
  border-radius: 10px;
}
button.btn.btn-primary {
  font-size: 12px;
  background: #0069d9;
}
.regbp {
  width: 90% !important;
  margin: auto;
  margin-top: 5%;
  display: flex;
  justify-content: space-between;
  button {
    width: 30% !important;
    font-size: 0.8em !important;
  }
}

.modal-dialog {
  margin: auto;
}
.modal-body {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  /* height: 50vh !important; */
}
.modalform {
  height: fit-content;

  .form-group{
    margin: 2% 5% !important;

    input,select {
      width: 100% !important;
    }
  }

  p {
    margin-top: 3.5%;
    margin-bottom: 1.5%;
  }
}
.modal-content {
  height: 100%;
}
@media only screen and (max-width: 600px) {
  .desc{
      margin-top: 7% !important;
  }
  .modalform {

  .form-group{
    margin: 2% 1% !important;
  }
}
.priceregistration{
  display: flex;
  flex-direction: column;
  
  form{
    width: 80% !important;

    div{
      padding: 0;
      margin-right: 5%;
    }
  }
}
  
}
</style>
